import { memo, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "../Modal";
import { AddSectionContent } from "./AddSectionContent";
import { AddSectionActions } from "./AddSectionActions";
import { addSectionModalOpenSelector } from "../../../reducers/ownApp/selectors";
import { setAddSectionModalOpen } from "../../../reducers/ownApp";
import { addSection } from "../../../reducers/sectionManagement/thunkActions";
import { sectionsSelector } from "../../../reducers/sectionManagement/selectors";
import { validateSection } from "../../../utils/sections";

export const AddSectionModal = memo(() => {
  const dispatch = useDispatch();
  const open = useSelector(addSectionModalOpenSelector);
  const sections = useSelector(sectionsSelector);
  const [sectionName, setSectionName] = useState("");

  useEffect(() => {
    setSectionName("");
  }, [open]);

  const onClose = () => {
    dispatch(setAddSectionModalOpen(false));
  };
  const onContinue = async () => {
    dispatch(addSection({ sectionName }));
    onClose();
  };

  const errors = validateSection({
    sectionEdit: { sectionName, sectionCode: null },
    sections,
  });

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={"Add New Section"}
      content={
        <AddSectionContent
          onSectionNameChange={({ target }) => setSectionName(target.value)}
          sectionName={sectionName}
          errors={errors}
        />
      }
      actions={
        <AddSectionActions
          disabled={!!Object.keys(errors).length}
          onCancel={onClose}
          onContinue={onContinue}
        />
      }
      maxWidth={"sm"}
    />
  );
});
